import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { PhoneNumberFormat } from 'src/app/models/customer/phone-number-format';
import { ToastControllerWrapperService } from '../toast-controller-wrapper/toast-controller-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor(
    public toasterWrapper: ToastControllerWrapperService,

  ) { }

  //REGION - PHONE NUMBER FORMAT

  validatePhoneNumberFormat(phoneNumberFormat) {
    //not allowed to have _'s in format because it's used as a placeholder - strip it out and notify the user
    if (phoneNumberFormat.indexOf("_") !== -1) {
      console.log("'_' character detected in phone number format. Stripping it out.");
      this.toasterWrapper.presentErrorToast(
        'The "_" character was detected in phone number format [' + phoneNumberFormat + '] and is not allowed as it is reserved as a placeholder and will be removed. Please contact your system administrator.'
      );
      phoneNumberFormat = phoneNumberFormat.replace(/_/g, '');
    }
    return phoneNumberFormat;
  }

  applyPhoneNumberFormat(phoneNumberFormat, phoneNumber) {
    var formattedPhoneNumber = '';
    var nextCharContactNumber = 0;
    for (var i = 0; i < phoneNumberFormat.length; i++) {
      var nextCharOfPhoneNumberFormat = phoneNumberFormat[i];
      if (nextCharOfPhoneNumberFormat == 'X') {
        if (phoneNumber != null && nextCharContactNumber < phoneNumber.length) {
          formattedPhoneNumber += phoneNumber[nextCharContactNumber];
          nextCharContactNumber++;
        }
        else {
          formattedPhoneNumber += '0';
        }
      }
      else {
        formattedPhoneNumber += nextCharOfPhoneNumberFormat;
      }
    }

    return formattedPhoneNumber;
  }

  createPhoneNumberMask(format: PhoneNumberFormat) {
    let phoneNumberFormat = format.phoneNumberFormat;
    var phoneNumberMask: (string | RegExp)[] = [];
    for (var i = 0; i < phoneNumberFormat.length; i++) {
      if (phoneNumberFormat[i] == 'X') {
        phoneNumberMask.push(/./);
      }
      else {
        phoneNumberMask.push(phoneNumberFormat[i]);
      }
    }

    return phoneNumberMask;
  }

  createPhonePlaceHolder(format: PhoneNumberFormat) {
    return format.phoneNumberFormat.replace(/X/g, '0');
  }

  unapplyPhoneNumberFormat(phoneNumberFormat: string, phoneNumber: string) {
    var unformatedPhoneNumber = "";
    for (var i = 0; i <= phoneNumberFormat.length; i++) {
      if (phoneNumberFormat[i] == 'X') {
        //wildcard for user input
        unformatedPhoneNumber += (phoneNumber && phoneNumber[i] ? phoneNumber[i] : '0');
      }
    }
    unformatedPhoneNumber = unformatedPhoneNumber.replace(/_/g, '0');
    return unformatedPhoneNumber;
  }

  requiredPhoneNumber(format: PhoneNumberFormat): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!format || !format.phoneNumberFormat) {
        return null;
      }
      let unformatterValue = this.unapplyPhoneNumberFormat(format.phoneNumberFormat, control.value);
      let notValid = (unformatterValue === '00000000000000');
      return notValid ? { required: true } : null;
    }
  }

  isEmptyPhoneNumber(phoneNumber: string)
  {
    return phoneNumber === '00000000000000';
  }

  //ENDREGION - PHONE NUMBER FORMAT
}
